import { useState } from "react"
import { Button, Icon, Modal } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { StatesDescription } from "~/shared/components/StatesDescription"
import { InvoicePaymentStateLabelsMap } from "../constants/invoices"

const states = Object.values(InvoicePaymentStateLabelsMap)

export const PaymentStatesPopup = () => {
  const { t } = useTranslation("Invoices")
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Icon
        name="InfoCircle"
        onClick={() => setIsOpen(true)}
        data-testid="open-payment-status-popup"
        className="cursor-pointer text-primary-base hover:text-primary-darken-100"
      />
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        data-testid="payment-status-popup"
      >
        <Modal.Header>{t("popup.paymentTitle")}</Modal.Header>
        <Modal.Content>
          <StatesDescription t={t} data={states} />
        </Modal.Content>
        <Modal.Footer>
          <Button variation="borderless" onClick={() => setIsOpen(false)}>
            {t("closeButton")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
